import * as React from "react";
import { useCpFormContext } from "../../form/useCpFormContext";
import { useBlocker } from "react-router-dom";
import { store } from "../../../store";
import { isEqual } from "lodash";
import { Button, Modal } from "antd";
import { sentryLog } from "../../../tools/sentry";

interface Props {
  link: string;
  dashboard?: "console" | "home";
  inputToItemFn: (input: any) => void;
  blockChildren?: boolean;
}
export const CpFormPromptDetail: React.FC<Props> = ({ link, inputToItemFn, dashboard = "console", blockChildren = false }) => {
  const { id } = useCpFormContext();

  const ignoreBlockerRef = React.useRef(false);
  const nextLocationRef = React.useRef("/");
  const blocker = useBlocker(({ currentLocation, nextLocation, historyAction }) => {
    const form = store.getState().form.instances[id];

    if (form.meta?.applied) return false;

    const init = form.initialValues;
    const curr = form.values;

    if (Object.keys(curr).length < 1) {
      return false;
    }

    const initItem = inputToItemFn(init);
    const currItem = inputToItemFn(curr);

    const isDirty = !!(curr.meta?.editableCard || "") || !isEqual(initItem, currItem);

    nextLocationRef.current = nextLocation.pathname;

    const linkPath = `/${dashboard}${link}`;
    const isNavigatingAway = blockChildren
      ? !nextLocation.pathname.startsWith(linkPath) || nextLocation.pathname.startsWith(`${linkPath}/`)
      : !nextLocation.pathname.includes(linkPath);
    const res =
      !ignoreBlockerRef.current &&
      currentLocation.pathname.includes(linkPath) &&
      isNavigatingAway &&
      isDirty;

    if (res) {
      sentryLog("blockedNavigation", {
        "data.ignoreBlockerRef": ignoreBlockerRef.current,
        "pathname.next": nextLocation.pathname,
        "pathname.current": currentLocation.pathname,
        "pathname.check": `/${dashboard}${link}`,
        res: res,
        isDirty: isDirty,
        isNavigatingAway: isNavigatingAway,
        "values.init": init,
        "values.current": curr,
        "item.init": initItem,
        "item.current": currItem,
      });
    }

    return res;
  });

  if (blocker.state === "blocked") {
    return (
      <Modal
        open={true}
        maskClosable={true}
        closable={true}
        onCancel={() => blocker.reset()}
        title={`Warning!`}
        footer={() => (
          <div className="flex items-center justify-end gap-4">
            <Button onClick={() => window.open(`${nextLocationRef.current}`)} type={`default`}>
              Open New Tab
            </Button>
            <Button onClick={() => blocker.reset()} type={`primary`}>
              Continue Editing
            </Button>
            <Button onClick={() => blocker.proceed()} type={`default`} danger>
              Discard Changes
            </Button>
          </div>
        )}
      >
        There are unsaved changes.
      </Modal>
    );
  }

  return null;
};
